
import externalConfiguration from '../external-configuration';
import { avoidCache, IE11_safeIncludes } from './utils';

import playerToState from './player-to-state';
import { legacyLoadVideo } from './legacy-to-state';
import { loadTaggingTranscription } from './tagging-to-state';

export default function iframeToState( id) {
  let promiseOfIframe = fetch( avoidCache( '/definition/vdmiframes/' + id + '.json')).then( response => response.json());
  return promiseOfIframe.then( iframe => {
    let promiseOfSettings = playerToState( iframe.content.playerId, iframe.user);
    if( iframe.baseType === 'vod') {
      promiseOfSettings = legacyLoadVideo( iframe.user, iframe.content.videoId, promiseOfSettings)
        .then( settings => Object.assign( settings, { visualizerType: 'Vod'}));
    } else if( iframe.baseType === 'live') {
      promiseOfSettings.then( settings => Object.assign( settings, { visualizerType: 'Live'}));
    } else if( iframe.baseType === 'playlist') {
      // TODO
    }
    if( IE11_safeIncludes( iframe.extras, 'tagging')) {
      promiseOfSettings = promiseOfSettings.then( settings => {
        settings.visualizerType = 'Tagging';
        settings.customProps.width = window.innerWidth * externalConfiguration.taggingSettings.playerSize;
        settings.visualizerOptions.onResize = state => {
          state.customProps.width = window.innerWidth * externalConfiguration.taggingSettings.playerSize;
          state.customProps.height = window.innerHeight;
          return state;
        };
        return loadTaggingTranscription( settings, iframe.user);
      });
    }
    if( IE11_safeIncludes( iframe.extras, 'chat')) {
      // TODO
    }
    return promiseOfSettings;
  });
}



// WEBPACK FOOTER //
// ./src/helpers/iframe-to-state.js